import './cartQuantity.less';
import {refreshCart, reloadCart} from "../cartActions/cartActions";
import {delay, nearestNumber} from "../../../js/core/Helpers/Helpers";

const cartQuantity = () => {

	let onQtyChange = () => {
		let quantityTimeout = null;
		let quantityInputTimeout = null;
		
		$(document).on("click", ".js-cart-quantity", function (e) {
			if (quantityTimeout != null) {
				clearTimeout(quantityTimeout);
			}
			
			let self = $(this);
			let input = $(self.data('target'));
			let value = parseInt(input.val());
			let step = parseInt(input.data('step') || 1);
			
			if (self.data('direction') == 'up' && value < input.data('max')) {
				input.val(value + step);
			} else if (self.data('direction') == 'down' && value > input.data('min')) {
				input.val(value - step);
			}
			
			if (self.data('cart') == 1) {
				let form = self.closest("form");
				if (form) {
					quantityTimeout = setTimeout(function () {
						$('body').append('<div id="js-page-locker" class="page-locker"></div>');
						form.submit();
					}, 400);
				}
			}
		});
		
		$(document).on("keyup", ".js-quantity-input", delay(function (e) {
			if (quantityInputTimeout != null) {
				clearTimeout(quantityInputTimeout);
			}

			let input = $(e.currentTarget);
			let value = parseInt(input.val()) || 1;
			let step = parseInt(input.data('step') || 1);

			if(value < step) {
				input.val(step);
			} else {
				input.val(nearestNumber(value, step, "up"));
			}

			quantityInputTimeout = setTimeout(function () {
				let form = input.closest("form");
				if(form && form.length) {
					$('body').append('<div id="js-page-locker" class="page-locker"></div>');
					form.submit();
				}

			}, 600);
		}, 500));
	};
	
	let onCartItemRemove = () => {
		$(document).on('click', '.js-remove-product-from-cart', function (e) {
			e.preventDefault();
			let self = $(this);
			let r = confirm(self.data('question'));
			console.log(r);
			if (r === true) {
				let quantityInput = $(self.data('target'));
				quantityInput.val(0);
				quantityInput.closest('form').submit();
			}
		});
	};
	
	let onCartDiscountRemove = () => {
		$(document).on('click', '.js-remove-discount-from-cart', function (e) {
			e.preventDefault();
			let self = $(this);
			let r = confirm(self.data('question'));
			if (r === true) {
				window.location = self.data('url');
			}
		});
	};
	
	let onCartServiceRemove = () => {
		$(document).on('click', '.js-remove-service-from-cart', function (e) {
			e.preventDefault();
			let self = $(this);
			let r = confirm(self.data('question'));
			if (r === true) {
				$.get('cart-remove-service,' + self.data('id') + '.html', function () {
					location.reload();
				});
			}
		});
	};
	
	onQtyChange();
	onCartItemRemove();
	onCartServiceRemove();
	onCartDiscountRemove();
	
	// const change = (event, input) => {
	//
	//     const remove = () => input.value = (input.value - 1) < 1 ? input.value : --input.value;
	//
	//     const isQuantityNumber = () => !isNaN(parseInt(input.value));
	//
	//
	//    if (!isQuantityNumber()){
	//        input.value = 1;
	//     } else {
	//        event.currentTarget.classList.contains('js-add-cart-quantity')
	//            ? ++input.value
	//            : remove();
	//     }
	//
	//
	// };
	//
	//
	// [...modules].map(module => {
	//     let controllers = module.getElementsByClassName('quantity-controller');
	//     let input = module.getElementsByClassName('quantity-input')[0];
	//
	//     [...controllers].map(controller => controller.addEventListener('click', e => change(e, input)));
	// });
	
};

export default cartQuantity;


// WEBPACK FOOTER //
// ./components/Cart/cartQuantity/cartQuantity.js